import {useIntegrator} from "../../integrator.context";
import {useState} from "react";
import {TechTreeComponent} from "../../models/remoteConstants.model";
import NumberInputLabel from "../../elements/numberInputLabel.element";
import {TechTierPrice, UpdateTechTierPriceCommand} from "../../commands/updateTechTierPrice.command";

function PriceList() {
    const {state, executeCommand} = useIntegrator();
    const [tab, setTab] = useState<TechTierPrice>(TechTierPrice.Cost);

    function getPricesForTab(t: TechTierPrice): number[] {
        switch (t) {
            case TechTierPrice.Cost:
                return state.techConfig?.prices ?? [];
            case TechTierPrice.Research:
                return state.techConfig?.researchTimes ?? [];
            case TechTierPrice.Score:
                return state.techConfig?.playerScores ?? [];
        }
    }

    const prices = getPricesForTab(tab);

    function getTierCount(): number {
        let count = -1;

        let cur: TechTreeComponent | undefined = state.techTree[0];
        while (cur !== undefined) {
            count++;
            // eslint-disable-next-line no-loop-func
            cur = state.techTree.find(t => t.id === cur?.children[0]);
        }

        return count;
    }

    function getTierPrice(tier: number): number {
        if (prices === undefined || tier >= prices.length) {
            return 0;
        }

        return prices[tier];
    }

    return (
        <div className={'layout vertical gap box'} style={{gap: 10}}>
            <div className={'layout horizontal gap stretch'}>
                <PriceTabButton cur={tab} tab={TechTierPrice.Cost} title={'Cost (Gold)'} onClick={setTab}/>
                <PriceTabButton cur={tab} tab={TechTierPrice.Research} title={'Research (Turns)'} onClick={setTab}/>
                <PriceTabButton cur={tab} tab={TechTierPrice.Score} title={'Player Scores'} onClick={setTab}/>
            </div>
            <div className={'layout vertical gap'}>
                {Array.from({length: getTierCount()}).map((_, index) => {
                    return <NumberInputLabel title={`Tier ${index + 1}`} value={getTierPrice(index)} onChange={v => {
                        executeCommand(new UpdateTechTierPriceCommand(index, v, tab));
                    }}/>
                })}
            </div>
        </div>
    )
}

function PriceTabButton(props: {cur: TechTierPrice, tab: TechTierPrice, title: string, onClick(tab: TechTierPrice): void}) {
    return (
        <p className={`text flex-grow box ${props.cur === props.tab && 'selected'}`}
           onClick={() => props.onClick(props.tab)}>{props.title}</p>
    )
}

export default PriceList;
